import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const ServiceCategoryNotFound = () => (
  <section>
    <header>
      <PageTitle>
        ServiceCategory not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default ServiceCategoryNotFound



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/ServiceCategoryNotFound.jsx